import React from "react";
import { SOFTWARE } from "../data/siteData";
import ServicePage from "./ServicePage";

export default function SoftwarePage({ onNavigate }) {
  return (
    <ServicePage hero={SOFTWARE.hero} onNavigate={onNavigate}>
      <section className="section">
        <div className="capability-grid">
          {SOFTWARE.pillars.map((p, i) => (
            <div key={i} className="capability-card">
              <div className="capability-card-header">
                <h4>{p.title}</h4>
                <span className="capability-icon">{p.icon}</span>
              </div>
              <p>{p.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </ServicePage>
  );
}
